module.exports = __webpack_public_path__ + "img/journal_large.723461bc.png";